import { AgGridReact } from 'ag-grid-react';
import React, { useState, useRef, useMemo, useCallback } from 'react';
import { UpdateService } from '../../services/UpdateService';
import { dateTimeFormatter, getDate, formatTimeDifference, formatTimeDifferenceSeconds } from './../../library/formatters';
import { getJobTasks } from '../../apis/taskApi';
import { CustomStateFilter } from '../Table/CustomFilters/CustomStateFilter';
import { getNumComparators, getTextComparators, getDateComparators } from '../../library/comparators';


export const JobTasks = ({jobId, isJobRunning, active, jobState}) => {

    const numComparators = getNumComparators();
    const dateComparators = getDateComparators();

    const gridRef = useRef();
    const defaultPageSize = 25;
    
    const getTasks = async (params) => {
        if (active)
        {
            const filters = params.filterModel;
            const sorting = params.sortModel;
            const response = await getJobTasks(jobId, filters, sorting, params.startRow, params.endRow-params.startRow)
                .then(response => {
                    return {total: response.total, data: response.data.map((fileRow => fileRow))};
            });
                    
            // if on or after the last page, work out the last row.
            let lastRow = response.total;
            params.successCallback(response.data, lastRow);
        }
    }
    
    const onGridReady = useCallback( async (params) => {
        const dataSource = {
          rowCount: undefined,
          getRows: getTasks
        };
        params.api.setGridOption('datasource', dataSource);
    });

    const pageSizeOptions=[15, 25, 50, 100]

    const refreshTable = () => {
        gridRef.current.api.refreshInfiniteCache();
    }

    const [colDefs, setColDefs] = useState([
        {field: "index", headerName: "Task Id", filter: 'agNumberColumnFilter', flex:1, filterParams :{filterOptions: numComparators, maxNumConditions: 1}, cellRenderer: JobTaskId},
        {field: "state", headerName: "Task State", filter: 'agTextColumnFilter', filter: CustomStateFilter , flex:1, filterParams: {title: "State Filter", filterOptions:['Completed', 'Failed', 'Generated', 'Started']}},
        {field: "created", filter: true, sortable: true, valueFormatter: dateTimeFormatter, flex:1, filterParams:{filterOptions : dateComparators, maxNumConditions: 1, maxValidYear:9999}},
        {field: "started", filter: true, sortable: true, valueFormatter: dateTimeFormatter, flex:1, filterParams:{filterOptions : dateComparators, maxNumConditions: 1, maxValidYear:9999}},
        {field: "completed", filter: true, sortable: true, valueFormatter: dateTimeFormatter, flex:1, filterParams:{filterOptions : dateComparators, maxNumConditions: 1, maxValidYear:9999}}, //LS the text comparator isn't going to work because it has contains
        {field: "duration", filter: 'agNumberColumnFilter', filterParams :{filterOptions: numComparators, maxNumConditions: 1}, sortable: true, flex:1, cellRenderer: TaskDurationCell, cellRendererParams: { gridRef: gridRef, jobState: jobState}}, 
        {field: "retryAttempt", headerName: "Retry Attempts", filter: 'agNumberColumnFilter', flex:1, filterParams:{filterOptions : numComparators, maxNumConditions: 1}},
    ]);

    const defaultColDef = useMemo(() => {
        return {
          flex: 1
        };
    }, []);

    return(
    <>
        <div className={'ag-theme-quartz'}>
            <AgGridReact
                suppressClickEdit={true}
                ref = {gridRef}
                pagination={true}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                enableClickSelection={false}
                rowModelType={'infinite'}
                onGridReady={onGridReady}
                paginationPageSize={defaultPageSize}
                paginationPageSizeSelector={pageSizeOptions}
                cacheBlockSize={defaultPageSize}
                cacheOverflowSize={2}
                maxConcurrentRequests={2}
                infiniteInitialRowCount={1}
                maxBlocksInCache={2}
            />
        </div>
        <UpdateService updateDataFunction={refreshTable} gridRef={gridRef} active={active} isJobRunning={isJobRunning}/> 
    </>
    ) 
}

const JobTaskId = ({value}) => {
    return <>{value + 1}</>;
}

const TaskDurationCell = ({data, jobState}) => {
    if (data)
    {
        if(data.started == null)
        {
            return <div className='text-muted'>Started Time Unavailable</div>
        }
        const startedDate = getDate(data.started);
        if(data.duration)
        {
            return <>{formatTimeDifferenceSeconds(data.duration)}</>;

        }
        else if(data.completed)
        {
            const completedDate = getDate(data.completed);
            const duration = completedDate - startedDate;
            return <>{formatTimeDifference(duration)}</>;
        }
        else if (jobState === 'Failed' || jobState === 'Cancelled' || jobState === 'Paused' ||data.completed === undefined || data.completed === null)
        {
            return <>  -</>
        }
    }
    return <>  -</>;
    
}
